module.exports = __webpack_public_path__ + "static/media/useful4.0df2fae9.png";